import React, { useContext } from 'react';
import styles from './index.module.less';
import classNames from 'classnames';
import { IStudyToolResult } from '@/types';
import { bindEvents } from '@/utils/sensors-data';
import SensorsDataContext from '@/components/home/context';
interface IProps {
    dataSource: IStudyToolResult['notice'];
}

const AlertBanner = (props: IProps) => {
    const sensorsDataContextValues = useContext(SensorsDataContext);

    const handleClick = (data: IStudyToolResult['notice']) => {
        bindEvents('pc_studytab_notice_click', {
            ...sensorsDataContextValues,
            notice_name: data!.noticeTitle,
            notice_id: data!.noticeId,
        });

        if (data!.jumpLink) {
            window.open(data!.jumpLink, '_blank');
        }
    };

    return (
        <div className={styles['alert-banner-wrap']}>
            <div
                className={classNames(styles['alert-banner'], {
                    [styles.pointer]: !!props.dataSource!.jumpLink,
                })}
                onClick={() => handleClick(props.dataSource)}
            >
                <img src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202407/02/71f8e_20240702155703.png" alt="" />
                公告：{props.dataSource!.noticeDesc}
            </div>
        </div>
    );
};

export default AlertBanner;
